/**
 * StepChips — fichas de paso ①②③ junto a una pestaña (patrón V2: pestaña
 * Diseño del detalle de proyecto). Genérico: un proyecto de Redes o SEO
 * define sus propios pasos sin cambiar la estructura. La activa se rellena
 * en cian; las demás son contorno. Los pasos son LIBRES — nunca bloquean.
 */
interface StepChipsProps {
  count: number;
  value: number;
  onChange: (n: number) => void;
  /** título accesible por paso (title/tooltip); recibe el número 1-based. */
  titleFor?: (n: number) => string;
}

export function StepChips({ count, value, onChange, titleFor }: StepChipsProps) {
  return (
    // Misma fila que las pestañas: ocupa el alto de la pestaña (--evo-tab-h)
    // anclado abajo, y centra los discos contra el texto del tab — así quedan
    // a la altura del label, no flotando por encima del subrayado.
    <div style={{ display: 'inline-flex', alignItems: 'center', height: 'var(--evo-tab-h)', gap: 'var(--evo-step-chip-gap)', marginLeft: 'var(--evo-step-chip-gap)', flexShrink: 0, alignSelf: 'flex-end' }}>
      {Array.from({ length: count }, (_, i) => i + 1).map(n => (
        <button
          key={n}
          type="button"
          title={titleFor ? titleFor(n) : String(n)}
          onClick={() => onChange(n)}
          style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            boxSizing: 'border-box',
            width: 'var(--evo-step-chip-sz)',
            height: 'var(--evo-step-chip-sz)',
            flexShrink: 0,
            borderRadius: 'var(--evo-r-pill)',
            background: value === n ? 'var(--evo-cyan)' : 'transparent',
            color: value === n ? 'var(--evo-fg-on-cyan)' : 'var(--evo-fg-3)',
            border: `1px solid ${value === n ? 'var(--evo-cyan)' : 'var(--evo-stroke)'}`,
            fontFamily: 'var(--evo-font)',
            fontSize: 'var(--evo-fs-tiny)',
            fontWeight: 'var(--evo-fw-medium)',
            lineHeight: 1, cursor: 'pointer',
          }}
        >
          {n}
        </button>
      ))}
    </div>
  );
}
